var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.content},[(_vm.header)?_c(_vm.headerTag,{tag:"component"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]):_vm._e(),_vm._v(" "),_c('UiRichText',{attrs:{"content":_vm.bodytext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }